import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { connect } from 'react-redux'
import config from 'SRC/config/config.json'
import StpdBannerComponent from 'stpd-ad-component'
import Link from 'next/link'
import { getIsMobileDevice } from 'SRC/modules/common/selectors'
import { getFormattedAdPrice } from 'SRC/utils'
import { QuickSearch } from 'SRC/modules/categories/components'
import { getCurrentAd, getIsServer, getIsMyAd } from '../../selectors'
import { HeadlineModel, HeadlinePrice, HeadlineBackUrl, HeadlineAdCode, HeadlineShowCounter } from '../Headline'
import { MainProps } from '../MainProps'
import { Equipment, EquipmentMobile } from '../Equipment'
import { getPriceTypeTitle } from '../../functions'
import { Description } from '../Description'
import { RightColumn } from '../RightColumn'
import { LeftColumn } from '../LeftColumn'
import { Location } from '../Location'
import { PhotosMobile } from '../PhotosMobile'
import { RegistrationPriceMobile } from '../RegistrationPriceMobile'
import { SimilarAds } from '../Tab'
import { CallButton } from '../CallButton'
import { EditAdButtons } from '../EditAdButtons'

const getUserPhone = user => {
  const findUserPhone = user && Array.isArray(user.phones) && user.phones.length
    ? user.phones[0]
    : null

  return findUserPhone ? findUserPhone.phone : ''
}

export const Content = ({ ad, isMyAd, isServer, isMobileDevice }) => {
  const { t } = useTranslation('common')

  const [windowWidth, setWindowWidth] = useState(0)

  useEffect(() => {
    setWindowWidth(window.innerWidth)
    const handleWindowResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize)
  }, [])

  const {
    seo,
    price,
    oldPrice,
    priceType,
    registrationCost,
    code,
    views,
    titleCompiled,
    category,
    description,
    country,
    city,
    location,
    discount,
    priceFrom,
    priceTo,
    priceOnRequest,
    typeOfPrice,
    user,
    status,
    activated,
    listingStatus,
    listingActivated
  } = ad

  return (
    <div className='oglasi-content-oglas' style={{ border: 'none' }}>
      <div className='oglasi-headline'>
        {isMobileDevice ? <PhotosMobile /> : null}
        <div className='oglasi-headline-left'>
          <HeadlineModel title={titleCompiled} />

          {status === 'Published' ? (
            <HeadlinePrice
              price={price}
              discount={oldPrice}
              priceType={getPriceTypeTitle(priceType)}
              priceFrom={priceFrom}
              priceTo={priceTo}
              priceOnRequest={priceOnRequest}
              typeOfPrice={typeOfPrice}
            />
          ) : null}
        </div>

        <div className='oglasi-headline-right'>
          {!isMobileDevice ? (
            <>
              <HeadlineAdCode code={code} />
              <HeadlineShowCounter count={Array.isArray(views) && views[0] ? views[0].count : 0} />
            </>
          ) : (
            <div className='oglasi-headline-ad-code-views'>
              <HeadlineAdCode code={code} />
              <HeadlineShowCounter count={Array.isArray(views) && views[0] ? views[0].count : 0} />
            </div>
          )}
        </div>

        {isMyAd && isMobileDevice ? <EditAdButtons /> : null}
      </div>

      {isMobileDevice ? (
        <div style={{ width: windowWidth <= 727 ? 320 : 728, margin: 'auto' }}>
          <StpdBannerComponent
            refreshOnUrlChange={true}
            adUnitPath={`/${config.banners.dfpNetworkId}/${config.banners.adDetails.mobileTop.adUnit}`}
            size={config.banners.adDetails.mobileTop.sizes}
            divId={config.banners.adDetails.mobileTop.slotId}
          />
        </div>
      ) : null}

      {category && category.specsShown ? <MainProps /> : null}

      <div className='oglasi-info-and-img'>
        <LeftColumn />
        {!isMobileDevice ? <RightColumn /> : null}
        <Location country={country && country.name} city={city && city.name} location={location && location.name} />
        {isMobileDevice ? <RegistrationPriceMobile price={registrationCost ? getFormattedAdPrice(registrationCost) : 0} /> : null}

        {!isMobileDevice ? <Equipment /> : <EquipmentMobile />}

        <Description description={description} />

        {!isMobileDevice ? (
          <>
            <div className='oglasi-slicni-oglasi'>
              <div className='oglasi-info-heading'>
                <p>{t('Slični oglasi')}</p>
              </div>

              <SimilarAds />
            </div>

            <QuickSearch page='ad' />
          </>
        ) : null}

        {isMobileDevice && !isMyAd && status === 'Published' ? <CallButton phone={getUserPhone(user)} /> : null}
      </div>

      {config.banners.adsList.afterAds && !isMobileDevice ? (
        <div style={{ width: 640, height: 100 }}>
          <StpdBannerComponent
            refreshOnUrlChange={true}
            adUnitPath={`/${config.banners.dfpNetworkId}/${config.banners.adsList.afterAds.adUnit}`}
            size={config.banners.adsList.afterAds.sizes}
            divId={config.banners.adsList.afterAds.slotId}
          />
        </div>
      ) : null}
    </div>
  )
}

Content.propTypes = {
  ad: PropTypes.shape({
    category: PropTypes.shape({
      specsShown: PropTypes.bool
    }),
    price: PropTypes.number.isRequired,
    priceFrom: PropTypes.number,
    priceTo: PropTypes.number,
    discount: PropTypes.number,
    oldPrice: PropTypes.number,
    priceType: PropTypes.number.isRequired,
    priceOnRequest: PropTypes.bool,
    code: PropTypes.string.isRequired,
    views: PropTypes.string.isRequired,
    titleCompiled: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    country: PropTypes.shape({
      name: PropTypes.string.isRequired
    }),
    city: PropTypes.shape({
      name: PropTypes.string.isRequired
    }),
    location: PropTypes.shape({
      name: PropTypes.string.isRequired
    }),
    typeOfPrice: PropTypes.object
  }).isRequired,
  isServer: PropTypes.bool.isRequired,
  isMyAd: PropTypes.bool.isRequired,
  isMobileDevice: PropTypes.bool.isRequired
}

Content.defaultProps = {
  isServer: true
}

const mapStateToProps = state => {
  return {
    ad: getCurrentAd(state),
    isMyAd: getIsMyAd(state),
    isServer: getIsServer(state),
    isMobileDevice: getIsMobileDevice(state)
  }
}

export default connect(mapStateToProps)(Content)
